import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { TransferConstructionSiteEnum } from 'src/app/enum/transfer-construction-site-enum';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { RentalPeriodModel } from 'src/app/models/rental/rental-period.model';
import { TransferConstructionSitePrintModel } from 'src/app/models/rental/transfer-construction-site-print.model';
import { TransferConstructionSiteModel } from 'src/app/models/rental/transfer-construction-site.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { FreightService } from 'src/app/services/management/freight.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { DevolutionService } from 'src/app/services/rental/devolution.service';
import { RemissionService } from 'src/app/services/rental/remission.service';
import { TransferConstructionSiteService } from 'src/app/services/rental/transfer-construction-site.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-transfer-construction-site',
  templateUrl: './register-transfer-construction-site.component.html',
  styleUrls: ['./register-transfer-construction-site.component.scss'],
  standalone: false,
})
export class RegisterTransferConstructionSiteComponent implements OnInit {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly devolutionService = inject(DevolutionService);
  private readonly formatService = inject(FormatService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly freightService = inject(FreightService);
  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly remissionService = inject(RemissionService);
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly transferConstructionSiteService = inject(TransferConstructionSiteService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);
  private readonly invoiceService = inject(InvoiceService);
  private readonly orderService = inject(OrderService);

  ascendant: boolean = true;
  branchId = 0;
  companyId: number = 0;
  dataPeriod: string = '';
  datePeriod: string = '';
  destinyClientId: number = 0;
  destinyCostCenters: any[] = [];
  destinyClientInvalid: boolean = false;
  destinyCostCenterInvalid: boolean = false;
  destinyNameClient: string = '';
  devolutionConsecutive: string = '';
  differentClientsMessage: string = '';
  disabledActions: boolean = true;
  disabledConfirmTransfer: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  expandedForm: boolean = true;
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formTransferConstructionSite: FormGroup = new FormGroup({});
  hasQuantityInZero: boolean = false;
  iconStateTransferConstructionSite: string = '';
  isDisabledButtonAnnul: boolean = false;
  isDisabledButtons: boolean = false;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listCostCentersOrigin: any[] = [];
  listCostCentersDestinity: any[] = [];
  listTransporters: any[] = [];
  listVehicles: any[] = [];
  listClients: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  messageStateTransferConstructionSite: string = '';
  nameWindow: string = "Captura Traslado Entre Obras"
  originClientId: number = 0;
  originNameClient: string = '';
  originCostCenters: any[] = [];
  originClientInvalid: boolean = false;
  originCostCenterInvalid: boolean = false;
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  printTransferConstructionSiteFormat: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  remissionConsecutive: string = '';
  rentalPeriod: RentalPeriodModel = new RentalPeriodModel();
  severityState: string = 'success';
  statePeriod: string | null = '';
  swconfirmTransfer: boolean = false;
  swFreight: boolean = false;
  titleStateTransferConstructionSite: string = '';
  transferConstructionSiteContract: TransferConstructionSiteModel = new TransferConstructionSiteModel();
  transferConstructionSiteId: number;
  transferConstructionSitePrintModel = new TransferConstructionSitePrintModel();
  transferConstructionSiteStateString: string = '';
  transporterId: number = 0;
  userAuthenticated: UserModel = new UserModel();
  url: string = "transfer-construction-site";
  vehicleId: number = 0;

  async ngOnInit() {
    this.validateForm(this.transferConstructionSiteContract);
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.transferConstructionSiteId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async handleInitialState() {
    if (this.transferConstructionSiteId) {
      await this.editTransferConstructionSite();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewTransferConstructionSite();
    }
  }

  addDaysToDate() {
    const dateContract = this.formTransferConstructionSite.get("dateTransferConstructionSite")?.value;
    const destinyDateInvoice: Date = moment(dateContract).add(1, 'days').toDate();
    setTimeout(() => this.formTransferConstructionSite.controls["destinyDateInvoice"].patchValue(destinyDateInvoice));
  }

  async annulTransferConstructionSite() {
    if (this.transferConstructionSiteContract.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'El traslado no está guardado.',
      );
      return;
    }
    if (this.permissionUpdatable) {
      const accepted = await this.confirmDialogService.confirm('¿Realmente desea anular el traslado?');
      if (accepted) {
        try {
          this.transferConstructionSiteContract = await firstValueFrom(
            this.transferConstructionSiteService.annulTransferConstructionSite(this.transferConstructionSiteId)
          );
          this.validateForm(this.transferConstructionSiteContract);
          this.toastHandlerService.showToast(
            'success',
            'El traslado se anuló exitosamente.',
          );
        } catch (error) {
          console.error('Error al anular el traslado.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para anular traslados. Comuníquese con el administrador del sistema.',
      );
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getAllLists('costCentersOrigin', 'costCentersDestinity', 'transporters', 'vehicles');
      this.createNewTransferConstructionSite();
    }
  }

  async changeConsecutive() {
    const branchId = this.formTransferConstructionSite.get("branchId")?.value;
    let consecutive = this.formTransferConstructionSite.get("consecutive")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.',
      );
      return;
    } else if (consecutive <= 0) {
      consecutive = null;
    }
    if (consecutive == null) {
      this.transferConstructionSiteId = 0;
      const modelTransferConstructionSite = new TransferConstructionSiteModel();
      modelTransferConstructionSite.branchId = branchId;
      this.transferConstructionSiteContract = modelTransferConstructionSite;
    } else {
      try {
        this.transferConstructionSiteContract = await firstValueFrom(this.transferConstructionSiteService
          .getTransferConstructionSiteByKeysAsync(branchId, consecutive));
        this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
        this.validateForm(this.transferConstructionSiteContract);
        this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
      } catch (error) {
        const modelTransferConstructionSite = new TransferConstructionSiteModel();
        modelTransferConstructionSite.transferConstructionSiteId = -1;
        modelTransferConstructionSite.branchId = branchId;
        modelTransferConstructionSite.consecutive = consecutive;
        console.error('Error al buscar el traslado por llaves.', error);
      }
    }
  }

  changeDateTransferConstructionSite() {
    const dateTransferConstructionSite = this.formTransferConstructionSite.get("dateTransferConstructionSite")?.value;
    this.formTransferConstructionSite.controls["originDateInvoice"].patchValue(dateTransferConstructionSite);
    this.changeSwDontChargeInvoiceDay(this.transferConstructionSiteContract.originSwDontChargeInvoiceDay);
    this.disabledDetail = true;
  }

  changeSwDontChargeInvoiceDay(checked: boolean) {
    const dateTransferConstructionSite = this.formTransferConstructionSite.get("dateTransferConstructionSite")?.value;
    this.transferConstructionSiteContract.originSwDontChargeInvoiceDay = checked;
    if (dateTransferConstructionSite) {
      const date = new Date(dateTransferConstructionSite);
      if (checked) {
        date.setDate(date.getDate());
      } else {
        date.setDate(date.getDate() + 1);
      }
      this.formTransferConstructionSite.controls["destinyDateInvoice"].patchValue(date);
      this.disabledDetail = true;
    }
  }

  changeDestinyTransportValue() {
    const transportValue = this.formTransferConstructionSite.get("destinyTransportValue")?.value;
    if (transportValue < 0) {
      this.toastHandlerService.showToast(
        'error',
        'El valor ingresado no es válido.'
      );
    }
    this.disabledDetail = true;
  }

  async changeDestinyCostCenter(costCenterId: number | null) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousCostCenterId = this.transferConstructionSiteContract.destinyCostCenterId;
      if (hasDetails && costCenterId !== previousCostCenterId) {
        this.toastHandlerService.showToast(
          'error',
          `No puede ${costCenterId === null ? 'limpiar' : 'cambiar'} el centro de costos destino si el traslado tiene detalle.`
        );
        setTimeout(() => this.formTransferConstructionSite.get('destinyCostCenterId')?.patchValue(previousCostCenterId));
        return;
      }

      if (!costCenterId) {
        const clientId = this.formTransferConstructionSite.get('destinyClientId')?.value;
        this.formTransferConstructionSite.patchValue({ destinyCostCenterId: null });
        this.destinyCostCenters = this.listCostCentersDestinity.filter(costCenter => !clientId || costCenter.clientId === clientId);
        return;
      }

      await this.validateCostCenterState(costCenterId, 'destiny', this.listCostCentersDestinity);
    } catch (error) {
      console.error('Error al obtener el centro de costos destino.', error);
    }
  }

  async changeDestinyClient(clientId: number | null) {
    const previousId = this.transferConstructionSiteContract.destinyCostCenter?.clientId;
    if (this.quantityDetails > 0 && clientId !== previousId) {
      this.toastHandlerService.showToast(
        'error',
        `No puede ${clientId === null ? 'limpiar' : 'cambiar'} el cliente destino si el traslado tiene detalle.`
      );
      setTimeout(() => this.formTransferConstructionSite.get('destinyClientId')?.patchValue(previousId));
      return;
    }
    if (!clientId || clientId !== previousId) {
      this.formTransferConstructionSite.get("destinyCostCenterId")?.patchValue(null);
    }

    this.destinyCostCenters = clientId
      ? this.listCostCentersDestinity.filter(costCenter => costCenter.clientId === clientId)
      : this.listCostCentersDestinity;

    if (clientId) {
      await this.validateClientState(clientId, 'destiny');
    }
  }

  close() {
    this.router.navigate(['/transfer-construction-site']);
  }

  async createNewTransferConstructionSite() {
    if (this.permissionUpdatable) {
      this.dataPeriod = '';
      this.originNameClient = '';
      this.destinyNameClient = '';
      this.remissionConsecutive = '';
      this.devolutionConsecutive = '';
      this.differentClientsMessage = '';
      this.originClientId = 0;
      this.quantityDetails = 0;
      this.destinyClientId = 0;
      this.transferConstructionSiteId = 0;
      this.expandedForm = true;
      setTimeout(() => this.addDaysToDate(), 0);
      setTimeout(() => this.disabledDetail = true, 0)
      this.transferConstructionSiteContract = new TransferConstructionSiteModel();
      this.transferConstructionSiteContract.branchId = this.branchId;
      this.transferConstructionSiteContract.originVehicleId = this.vehicleId;
      this.transferConstructionSiteContract.destinyVehicleId = this.vehicleId;
      this.transferConstructionSiteContract.originTransporterId = this.transporterId;
      this.transferConstructionSiteContract.destinyTransporterId = this.transporterId;
      await this.validateForm(this.transferConstructionSiteContract);
      this.location.replaceState(`/transfer-construction-site/register`);
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear traslados. Comuníquese con el administrador del sistema'
      );
    }
  }

  changeOriginTransportValue() {
    const transportValue = this.formTransferConstructionSite.get("originTransportValue")?.value;
    if (transportValue < 0) {
      this.toastHandlerService.showToast(
        'error',
        'El valor ingresado no es válido.'
      );
    }
    this.disabledDetail = true;
  }

  async changeOriginCostCenter(costCenterId: number | null) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousCostCenterId = this.transferConstructionSiteContract.originCostCenterId;
      if (hasDetails && costCenterId !== previousCostCenterId) {
        this.toastHandlerService.showToast(
          'error',
          `No puede ${costCenterId === null ? 'limpiar' : 'cambiar'} el centro de costos origen si el traslado tiene detalle.`
        );
        setTimeout(() => this.formTransferConstructionSite.get('originCostCenterId')?.patchValue(previousCostCenterId));
        return;
      }

      if (!costCenterId) {
        const clientId = this.formTransferConstructionSite.get('originClientId')?.value;
        this.formTransferConstructionSite.patchValue({ originCostCenterId: null });
        this.originCostCenters = this.listCostCentersOrigin.filter(costCenter => !clientId || costCenter.clientId === clientId);
        return;
      }

      await this.validateCostCenterState(costCenterId, 'origin', this.listCostCentersOrigin);
    } catch (error) {
      console.error('Error al obtener el centro de costos origen.', error);
    }
  }

  async changeOriginClient(clientId: number | null) {
    const previousId = this.transferConstructionSiteContract.originCostCenter?.clientId;
    if (this.quantityDetails > 0 && clientId !== previousId) {
      this.toastHandlerService.showToast(
        'error',
        `No puede ${clientId === null ? 'limpiar' : 'cambiar'} el cliente origen si el traslado tiene detalle.`
      );
      setTimeout(() => this.formTransferConstructionSite.get('originClientId')?.patchValue(previousId));
      return;
    }

    if (!clientId || clientId !== previousId) {
      this.formTransferConstructionSite.get('originCostCenterId')?.patchValue(null);
    }

    this.originCostCenters = clientId
      ? this.listCostCentersOrigin.filter(costCenter => costCenter.clientId === clientId)
      : this.listCostCentersOrigin;

    if (clientId) {
      await this.validateClientState(clientId, 'origin');
    }
  }

  convertUtcToLocalDate(dateStr: string | Date): Date {
    const utcDate = new Date(dateStr);
    return new Date(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate()
    );
  }

  async changeStateTransferConstructionSite() {
    if (this.transferConstructionSiteContract.transferConstructionSiteId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'El traslado no está guardado.',
      );
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.transferConstructionSiteContract = await firstValueFrom(
          this.transferConstructionSiteService.setStateTransferConstructionSite(this.transferConstructionSiteId)
        );
        this.validateForm(this.transferConstructionSiteContract);
        this.toastHandlerService.showToast(
          'success',
          'El estado del traslado se modificó exitosamente.'
        );
      } catch (error) {
        console.error('Error al modificar el estado del traslado.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para modificar el estado del traslado. Comuníquese con el administrador del sistema.',
      );
    }
  }

  async confirmTransfer() {
    if (this.transferConstructionSiteContract.transferConstructionSiteId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'El traslado no está guardado.',
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm(
      '¿Realmente desea confirmar el traslado? <br> Recuerde revisar los precios por c.costos del c.costos de destino.'
    );
    if (accepted) {
      try {
        this.transferConstructionSiteContract = await firstValueFrom(
          this.transferConstructionSiteService.confirmTransferConstructionSite(
            this.transferConstructionSiteContract.transferConstructionSiteId
          )
        );
        this.validateForm(this.transferConstructionSiteContract);
        this.toastHandlerService.showToast(
          'success',
          'El traslado fue confirmado exitosamente.'
        );
      } catch (error) {
        console.error('Error al confirmar el traslado.', error);
      }
    }
  }

  async deleteTransferConstructionSite() {
    if (this.transferConstructionSiteContract.transferConstructionSiteId != 0) {
      if (this.permissionUpdatable) {
        const accepted = await this.confirmDialogService.confirm(
          `¿Realmente desea eliminar el traslado ${this.transferConstructionSiteContract.consecutive}?`
        );
        if (accepted) {
          try {
            await firstValueFrom(
              this.transferConstructionSiteService.deleteTransferConstructionSite(
                this.transferConstructionSiteContract.transferConstructionSiteId)
            );
            this.toastHandlerService.showToast(
              'success',
              'El traslado fue eliminado exitosamente.'
            );
            this.transferConstructionSiteContract = new TransferConstructionSiteModel();
            this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
            this.createNewTransferConstructionSite();
            this.validateForm(this.transferConstructionSiteContract);
          } catch (error) {
            console.error('Error al eliminar el traslado.', error);
          }
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para eliminar traslados. Comuníquese con el administrador del sistema.',
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado del traslado',
      );
    }
  }

  async editTransferConstructionSite() {
    await this.getTransferConstructionSiteById();
    this.validateForm(this.transferConstructionSiteContract);
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swFreight = response.some(x => x.name === GeneralParameters.freight);
      this.swconfirmTransfer = response.some(x => x.generalParameterId === GeneralParameterEnums.confirmaTrasladoObra);
    });
    this.listObservers.push(load);
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'clients' | 'costCentersDestinity' |
    'costCentersOrigin' | 'transporters' | 'vehicles'>) {
    try {
      const lists = {
        branches: async () => {
          const response = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
          this.listBranches = response;
        },
        clients: async () => {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.getClientsForSelectAsync()
          );
          this.listClients = response;
        },
        costCentersDestinity: async () => {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.getAllCostCenterForDestinitySelect(this.branchId)
          );
          this.destinyCostCenters = this.listCostCentersDestinity = response;
        },
        costCentersOrigin: async () => {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.getAllCostCenterForOriginSelect(this.branchId)
          );
          this.originCostCenters = this.listCostCentersOrigin = response;
        },
        transporters: async () => {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.getAllTransporterForSelect(this.branchId)
          );
          this.listTransporters = response;
          const defaultTransporter = this.listTransporters.find(x => x.isDefault);
          if (defaultTransporter) {
            this.transporterId = defaultTransporter.value;
          }
        },
        vehicles: async () => {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.getAllVehicleForSelect(this.branchId)
          );
          this.listVehicles = response;
          const defaultVehicle = this.listVehicles.find(x => x.isDefault);
          if (defaultVehicle) {
            this.vehicleId = defaultVehicle.value;
          }
        },
      };

      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.clients(),
          lists.costCentersDestinity(),
          lists.costCentersOrigin(),
          lists.transporters(),
          lists.vehicles(),
        ]);
      }

      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error al obtener las listas.', error);
    }
  }

  async getRentalPeriodByIdForRegisterInvoiceAsync() {
    this.rentalPeriod = await firstValueFrom(
      this.transferConstructionSiteService.getRentalPeriodByIdForRegisterInvoiceAsync(this.transferConstructionSiteContract.rentalPeriodId)
    );
    this.statePeriod = this.rentalPeriod.active ? 'Abierto' : 'Cerrado';
    this.datePeriod = `${this.rentalPeriod.year} - ${this.rentalPeriod.period}`;
    this.dataPeriod = `${this.datePeriod} - ${this.statePeriod}`;
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formTransferConstructionSite.get("branchId")?.value;
    let consecutive = this.formTransferConstructionSite.get("consecutive")?.value;
    if (branchId == null || branchId === 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    } else if (consecutive === 0) {
      consecutive = null;
    }
    switch (buttonClick.target.id) {
      case 'first':
        try {
          this.transferConstructionSiteContract = await firstValueFrom(
            this.transferConstructionSiteService.getFirstTransferConstructionSiteByKeysAsync(branchId));
          this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
          this.validateForm(this.transferConstructionSiteContract);
          this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
        } catch (error) {
          console.error('Error al buscar el primer traslado.', error);
        }
        break;
      case 'previus':
        try {
          this.transferConstructionSiteContract = await firstValueFrom(
            this.transferConstructionSiteService.getPreviusTransferConstructionSiteByKeysAsync(branchId, consecutive));
          this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
          this.validateForm(this.transferConstructionSiteContract);
          this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
        } catch (error) {
          console.error('Error al buscar el traslado anterior.', error);
        }
        break;
      case 'next':
        try {
          this.transferConstructionSiteContract = await firstValueFrom(
            this.transferConstructionSiteService.getNextTransferConstructionSiteByKeysAsync(branchId, consecutive));
          this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
          this.validateForm(this.transferConstructionSiteContract);
          this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
        } catch (error) {
          console.error('Error al buscar el traslado siguiente.', error);
        }
        break;
      case 'last':
        try {
          this.transferConstructionSiteContract = await firstValueFrom(
            this.transferConstructionSiteService.getLastTransferConstructionSiteByKeysAsync(branchId));
          this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
          this.validateForm(this.transferConstructionSiteContract);
          this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
        } catch (error) {
          console.error('Error al buscar el ultimo traslado.', error);
        }
        break;
      default:
        return;
    }
  }

  getCostCenter(originCostCenterId: number | null, destinyCostCenterId: number | null) {
    const sides = [
      {
        id: originCostCenterId,
        masterList: this.listCostCentersOrigin,
        listKey: 'originCostCenters' as const,
        clientInvalidKey: 'originClientInvalid' as const,
        centerInvalidKey: 'originCostCenterInvalid' as const,
        clientFormKey: 'originClientId'
      },
      {
        id: destinyCostCenterId,
        masterList: this.listCostCentersDestinity,
        listKey: 'destinyCostCenters' as const,
        clientInvalidKey: 'destinyClientInvalid' as const,
        centerInvalidKey: 'destinyCostCenterInvalid' as const,
        clientFormKey: 'destinyClientId'
      }
    ];

    const patchValues: any = { originCostCenterId, destinyCostCenterId };
    sides.forEach(side => {
      const costCenter = side.masterList.find(x => x.value === side.id);

      if (!costCenter) {
        this[side.listKey] = side.masterList;
        this[side.clientInvalidKey] = false;
        this[side.centerInvalidKey] = false;
        patchValues[side.clientFormKey] = null;
        return;
      }

      const client = this.listClients.find(x => x.value === costCenter.clientId);
      this[side.listKey] = side.masterList.filter(x => x.clientId === costCenter.clientId);
      this[side.clientInvalidKey] = client?.clientStateId === ClientStateEnums.inactivo;
      this[side.centerInvalidKey] = costCenter.constructionSiteStateId === ConstructionSiteStateEnums.inactiva;
      patchValues[side.clientFormKey] = costCenter.clientId;
    });

    setTimeout(() => this.formTransferConstructionSite.patchValue(patchValues));
  }

  async getDestinyVehicle(destinyVehicleIdNew: number | null) {
    const destinyVehicleOld = this.transferConstructionSiteContract.destinyVehicleId;
    const costCenterId = this.formTransferConstructionSite.get("destinyCostCenterId")?.value;
    if (destinyVehicleIdNew != null && destinyVehicleIdNew != 0) {
      if (destinyVehicleOld != destinyVehicleIdNew) {
        if (this.quantityDetails != 0) {
          const accepted = await this.confirmDialogService.confirm(
            `El traslado tiene artículos asociados. ¿Realmente desea modificar el vehículo?`
          );
          if (accepted) {
            if (this.swFreight) this.getFreightByRemission(costCenterId, destinyVehicleIdNew);
            this.disabledDetail = true;
          } else {
            setTimeout(() => {
              this.formTransferConstructionSite.controls["destinyVehicleId"].patchValue(destinyVehicleOld)
            });
          }
        } else {
          if (this.swFreight) this.getFreightByRemission(costCenterId, destinyVehicleIdNew);
          this.disabledDetail = true;
        }
      }
    } else {
      //Si el traslado tiene detalle no puede quedar sin vehículo:
      if (this.quantityDetails != 0) {
        setTimeout(() => {
          this.formTransferConstructionSite.controls["destinyVehicleId"].patchValue(destinyVehicleOld)
        });
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el vehículo si el traslado tiene detalle.'
        );
      } else {
        this.formTransferConstructionSite.controls["destinyVehicleId"].patchValue(0);
      }
    }
  }

  async getDevolutionConsecutiveByIdAsync(remisionId: number | null) {
    if (remisionId != null && remisionId != 0) {
      const response = await firstValueFrom(this.devolutionService.getDevolutionConsecutiveByIdAsync(remisionId));
      this.devolutionConsecutive = response.toString();
    } else {
      this.devolutionConsecutive = "";
    }
  }

  async getOriginVehicle(oringVehicleIdNew: number | null) {
    const oringVehicleIdOld = this.transferConstructionSiteContract.originVehicleId;
    const costCenterId = this.formTransferConstructionSite.get("originCostCenterId")?.value;
    if (oringVehicleIdNew != null && oringVehicleIdNew !== 0) {
      if (oringVehicleIdOld != oringVehicleIdNew) {
        if (this.quantityDetails > 0) {
          const accepted = await this.confirmDialogService.confirm(
            `El traslado tiene artículos asociados. ¿Realmente desea modificar el vehículo?`
          );
          if (accepted) {
            if (this.swFreight) this.getFreightByDevolution(costCenterId, oringVehicleIdNew);
            this.disabledDetail = true;
          } else {
            setTimeout(() => {
              this.formTransferConstructionSite.controls["originVehicleId"].patchValue(oringVehicleIdOld)
            });
          }
        } else {
          if (this.swFreight) this.getFreightByDevolution(costCenterId, oringVehicleIdNew);
          this.disabledDetail = true;
        }
      }
    } else {
      // Si el valor es nulo o 0 y hay detalles, no permitir quitar
      if (this.quantityDetails > 0) {
        setTimeout(() => {
          this.formTransferConstructionSite.controls["originVehicleId"].patchValue(oringVehicleIdOld);
        });
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el vehículo si el traslado tiene detalle.'
        );
      } else {
        this.formTransferConstructionSite.controls["originVehicleId"].patchValue(0);
      }
    }
  }

  async getFreightByDevolution(costCenterId: number, VehicleId: number) {
    if (VehicleId != null && costCenterId != null) {
      /*recupera un flete segun typeVehicle dentro de los registro de obra sino buscara en fletes generales de las mismas
      condiciones de ubicacion de la obra
      */
      try {
        const freight = await firstValueFrom(this.freightService.getFreightByDocumentRental(costCenterId, VehicleId));
        if (freight) {
          this.formTransferConstructionSite.controls["originTransportValue"].patchValue(freight.value);
          this.changeOriginTransportValue();
        } else {
          this.toastHandlerService.showToast(
            'info',
            'No se ha definido valor de flete para el lugar de destino de la obra seleccionada'
          );
          this.formTransferConstructionSite.controls['originTransportValue'].patchValue(0);
        }
      } catch (error) {
        console.error('Error al consultar el servicio:', error);
      }
    }
  }

  async getFreightByRemission(costCenterId: number, VehicleId: number) {
    if (VehicleId != null && costCenterId != null) {
      /*recupera un flete segun typeVehicle dentro de los registro de obra sino buscara en fletes generales de las mismas
      condiciones de ubicacion de la obra
      */
      try {
        const freight = await firstValueFrom(this.freightService.getFreightByDocumentRental(costCenterId, VehicleId));
        if (freight) {
          this.formTransferConstructionSite.controls["destinyTransportValue"].patchValue(freight.value);
          this.changeDestinyTransportValue();
        } else {
          this.toastHandlerService.showToast(
            'info',
            'No se ha definido valor de flete para el lugar de destino de la obra seleccionada'
          );
          this.formTransferConstructionSite.controls['destinyTransportValue'].patchValue(0);
        }
      } catch (error) {
        console.error('Error al consultar el servicio:', error);
      }
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getAllLists();
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    try {
      const formatCode = FormatsEnums.transferConstructionSite;
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId, formatCode));
    } catch (error) {
      console.error('Error al obtener el formato por compañía y código.', error);
    }
  }

  async getTransferConstructionSiteById() {
    try {
      const id = this.transferConstructionSiteId;
      const response = await firstValueFrom(this.transferConstructionSiteService.getTransferConstructionSiteById(id));
      await this.changeBranch(response.branchId, true);
      this.transferConstructionSiteId = response.transferConstructionSiteId;
      this.transferConstructionSiteContract = response;
    } catch (error) {
      console.error('Error al obtener el traslado.', error);
    }
  }

  async getOriginTransporter(originTransporterIdNew: number | null) {
    const originTransporterIdOld = this.transferConstructionSiteContract.originTransporterId;
    if (originTransporterIdNew != null && originTransporterIdNew != 0) {
      //Si cambia el transportador y el traslado tiene detalle, pregunto si realmente desea cambiar el transportador:
      if ((originTransporterIdOld != originTransporterIdNew) && this.quantityDetails != 0) {
        const accepted = await this.confirmDialogService.confirm(
          `El traslado tiene artículos asociados. ¿Realmente desea modificar el transportador del centro de costos origen?`
        );
        if (accepted) {
          this.disabledDetail = true;
        } else {
          setTimeout(() => {
            this.formTransferConstructionSite.controls["originTransporterId"].patchValue(originTransporterIdOld)
          });
        }
      }
    } else {
      //Si el traslado tiene detalle no puede quedar sin transportador:
      if (this.quantityDetails != 0) {
        setTimeout(() => {
          this.formTransferConstructionSite.controls["originTransporterId"].patchValue(originTransporterIdOld)
        });
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el transportador del centro de costos origen si el traslado tiene detalle.'
        );
      } else {
        this.formTransferConstructionSite.controls["originTransporterId"].patchValue(0);
      }
    }
  }

  async getDestinyTransporter(destinyTransporterIdNew: number | null) {
    const destinyTransporterIdOld = this.transferConstructionSiteContract.destinyTransporterId;
    if (destinyTransporterIdNew != null && destinyTransporterIdNew != 0) {
      //Si cambia el transportador y el traslado tiene detalle, pregunto si realmente desea cambiar el transportador:
      if ((destinyTransporterIdOld != destinyTransporterIdNew) && this.quantityDetails != 0) {
        const accepted = await this.confirmDialogService.confirm(
          `El traslado tiene artículos asociados. ¿Realmente desea modificar el transportador del centro de costos destino?`
        );
        if (accepted) {
          this.disabledDetail = true;
        } else {
          setTimeout(() => {
            this.formTransferConstructionSite.controls["destinyTransporterId"].patchValue(destinyTransporterIdOld)
          });
        }
      }
    } else {
      //Si el traslado tiene detalle no puede quedar sin transportador:
      if (this.quantityDetails != 0) {
        setTimeout(() => {
          this.formTransferConstructionSite.controls["destinyTransporterId"].patchValue(destinyTransporterIdOld)
        });
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el transportador del centro de costos destino si el traslado tiene detalle.'
        );
      } else {
        this.formTransferConstructionSite.controls["destinyTransporterId"].patchValue(0);
      }
    }
  }

  async getRemissionConsecutiveByIdAsync(remisionId: number | null) {
    if (remisionId != null && remisionId != 0) {
      const response = await firstValueFrom(this.remissionService.getRemissionConsecutiveByIdAsync(remisionId));
      this.remissionConsecutive = response.toString()
    } else {
      this.remissionConsecutive = "";
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.getGeneralParametersByCompany();
    this.getPermissionsForUserByWindow();
    await Promise.all([
      this.getPermissionPrint(),
      this.getPermissionProfileByUrl()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  getPermissionsForUserByWindow() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.userAuthenticated = user;
        this.companyId = user.companyId;
      });
    this.listObservers.push(load);
  }

  async getPermissionPrint() {
    try {
      // Obtenemos la respuesta de la API de manera sincrónica usando firstValueFrom
      this.permissionPrint = await firstValueFrom(this.transferConstructionSiteService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión o actulizar estado', error);
    }
  }

  async getPrintTransferConstructionSite(reload: boolean) {
    try {
      const id = this.transferConstructionSiteContract.transferConstructionSiteId;
      const response = await firstValueFrom(this.transferConstructionSiteService.printTransferConstructionSite(id, reload));
      this.transferConstructionSitePrintModel = response;
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/transfer-construction-site']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async printPage() {
    if (!this.transferConstructionSiteId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado del traslado.',
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir traslado entre obras. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (this.hasQuantityInZero) {
      this.toastHandlerService.showToast(
        'warning',
        'No puede imprimir si el traslado tiene detalles con cantidades en cero.'
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    this.printTransferConstructionSiteFormat = true;
    await this.getPrintTransferConstructionSite(true);
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
    this.transferConstructionSiteContract.transferConstructionSiteStateId = TransferConstructionSiteEnum.impresa;
    this.validateForm(this.transferConstructionSiteContract);
    this.printTransferConstructionSiteFormat = false;
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.transferConstructionSiteId != 0 && this.transferConstructionSiteId != null) {
      this.router.navigate(['/transfer-construction-site/register/', this.transferConstructionSiteId]);
    } else {
      this.router.navigate(['/transfer-construction-site/register']);
    }
  }

  async send() {
    if (this.formTransferConstructionSite.valid) {
      this.formTransferConstructionSite.enable();
      const model = this.formTransferConstructionSite.value as TransferConstructionSiteModel;
      //Hago null, los campos que permiten ser nulos:
      if (model.observation == "") model.observation = null;
      if (this.transferConstructionSiteId == 0) {
        try {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.createTransferConstructionSite(model)
          );
          this.transferConstructionSiteContract = response;
          this.transferConstructionSiteId = this.transferConstructionSiteContract.transferConstructionSiteId;
          this.validateForm(this.transferConstructionSiteContract);
          this.toastHandlerService.showToast(
            'success',
            `El traslado fue creado exitosamente.`
          );
          this.location.replaceState(`/transfer-construction-site/register/${this.transferConstructionSiteId}`);
        } catch (error) {
          console.error('Error al crear el traslado.', error);
        }
      } else {
        this.transferConstructionSiteContract.branchId = model.branchId;
        this.transferConstructionSiteContract.dateTransferConstructionSite = model.dateTransferConstructionSite;
        this.transferConstructionSiteContract.transferConstructionSiteStateId = model.transferConstructionSiteStateId;
        this.transferConstructionSiteContract.originSwDontChargeInvoiceDay = model.originSwDontChargeInvoiceDay;
        this.transferConstructionSiteContract.originCostCenterId = model.originCostCenterId;
        this.transferConstructionSiteContract.originTransporterId = model.originTransporterId;
        this.transferConstructionSiteContract.originVehicleId = model.originVehicleId;
        this.transferConstructionSiteContract.originTransportValue = model.originTransportValue;
        this.transferConstructionSiteContract.originDateInvoice = model.originDateInvoice;
        this.transferConstructionSiteContract.destinyCostCenterId = model.destinyCostCenterId;
        this.transferConstructionSiteContract.destinyTransporterId = model.destinyTransporterId;
        this.transferConstructionSiteContract.destinyVehicleId = model.destinyVehicleId;
        this.transferConstructionSiteContract.destinyTransportValue = model.destinyTransportValue;
        this.transferConstructionSiteContract.destinyDateInvoice = model.destinyDateInvoice;
        this.transferConstructionSiteContract.observation = model.observation;
        try {
          const response = await firstValueFrom(
            this.transferConstructionSiteService.updateTransferConstructionSite(this.transferConstructionSiteContract)
          );
          this.toastHandlerService.showToast(
            'success',
            `El traslado fue modificado exitosamente.`
          );
          this.transferConstructionSiteContract = response;
          this.validateForm(this.transferConstructionSiteContract);
        } catch (error) {
          console.error('Error al actualizar el traslado.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      dateTransferConstructionSite: 'El campo fecha es obligatorio.',
      originCostCenterId: 'El campo centro de costos origen es obligatorio.',
      originDateInvoice: 'El campo fecha devolución es obligatorio.',
      originTransporterId: 'El campo transportador origen es obligatorio.',
      originVehicleId: 'El campo vehículo origen es obligatorio.',
      destinyCostCenterId: 'El campo centro de costos destino es obligatorio.',
      destinyDateInvoice: 'El campo fecha remisión es obligatorio.',
      destinyTransporterId: 'El campo transportador destino es obligatorio.',
      destinyVehicleId: 'El campo vehículo destino es obligatorio.',
    };
    Object.keys(controlMessages).forEach(control => {
      if (this.formTransferConstructionSite.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención.');
      }
    });
  }

  onQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
  }

  async updateFormState() {
    switch (this.transferConstructionSiteContract.transferConstructionSiteStateId) {
      case TransferConstructionSiteEnum.abierta: {
        this.iconStateTransferConstructionSite = 'pi pi-lock-open';
        this.titleStateTransferConstructionSite = 'Cerrar';
        this.transferConstructionSiteStateString = "Abierto";
        this.severityState = 'danger';
        this.isDisabledButtons = false;
        this.isDisabledButtonAnnul = false;
        this.disabledConfirmTransfer = true;
        break;
      }
      case TransferConstructionSiteEnum.cerrada: {
        this.iconStateTransferConstructionSite = 'pi pi-lock';
        this.titleStateTransferConstructionSite = 'Reversar Estado';
        this.transferConstructionSiteStateString = "Cerrado";
        this.severityState = 'success';
        this.isDisabledButtons = false;
        this.isDisabledButtonAnnul = false;
        this.disabledConfirmTransfer = true;
        break;
      }
      case TransferConstructionSiteEnum.anulada: {
        this.iconStateTransferConstructionSite = 'pi pi-lock';
        this.titleStateTransferConstructionSite = 'Reversar Estado';
        this.transferConstructionSiteStateString = "Anulado";
        this.severityState = 'warn';
        this.isDisabledButtonAnnul = true;
        this.disabledConfirmTransfer = true;
        break;
      }
      case TransferConstructionSiteEnum.impresa: {
        this.iconStateTransferConstructionSite = 'pi pi-lock';
        this.transferConstructionSiteStateString = "Impreso";
        this.titleStateTransferConstructionSite = 'Abrir';
        this.severityState = 'success';
        this.disabledConfirmTransfer = false;
        break;
      }
      case TransferConstructionSiteEnum.enTransito: {
        this.iconStateTransferConstructionSite = 'pi pi-replay';
        this.transferConstructionSiteStateString = "En Tránsito";
        this.titleStateTransferConstructionSite = 'Reversar Estado';
        this.severityState = 'success';
        this.disabledConfirmTransfer = false;
        break;
      }
    }
    const transferConstructionSiteStateId = this.transferConstructionSiteContract.transferConstructionSiteStateId;
    if (transferConstructionSiteStateId == TransferConstructionSiteEnum.abierta) {
      this.disabledForm = false;
      this.disabledDetail = false;
      this.disabledActions = false;
      setTimeout(() => this.formTransferConstructionSite.enable());
      if (this.transferConstructionSiteContract.transferConstructionSiteId != 0) {
        setTimeout(() => this.formTransferConstructionSite.controls["consecutive"].enable());
      } else {
        setTimeout(() => this.formTransferConstructionSite.controls["consecutive"].disable());
        this.disabledDetail = true;
      }
    } else {
      this.disabledForm = true;
      this.disabledDetail = true;
      this.disabledActions = true;
      setTimeout(() => {
        this.formTransferConstructionSite.disable();
        this.formControlStateService.setControlState(this.formTransferConstructionSite, ['branchId', 'consecutive'], true);
      });
    }
    // Valido si el usuario tiene permisos de actualizacion
    if (!this.permissionUpdatable) setTimeout(() => this.formTransferConstructionSite.disable());
    setTimeout(() => this.formTransferConstructionSite.controls["destinyDateInvoice"].disable());
    setTimeout(() => this.formTransferConstructionSite.controls["originDateInvoice"].disable());
  }

  async validateForm(transferConstructionSite: TransferConstructionSiteModel) {
    this.formTransferConstructionSite = this.formBuilder.group({
      branchId: [transferConstructionSite.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [transferConstructionSite.consecutive],
      dateTransferConstructionSite: [transferConstructionSite.dateTransferConstructionSite
        ? this.convertUtcToLocalDate(transferConstructionSite.dateTransferConstructionSite)
        : null, [Validators.required]],
      destinyClientId: [transferConstructionSite?.destinyCostCenter?.clientId],
      destinyCostCenterId: [
        transferConstructionSite.destinyCostCenterId,
        [Validators.required, Validators.min(1)]
      ],
      destinyDateInvoice: [transferConstructionSite.destinyDateInvoice
        ? this.convertUtcToLocalDate(transferConstructionSite.destinyDateInvoice)
        : null, [Validators.required]],
      destinyTransportValue: [
        transferConstructionSite.destinyTransportValue,
        [Validators.required, Validators.min(0), Validators.max(99999999999.99)]
      ],
      destinyTransporterId: [
        transferConstructionSite.destinyTransporterId,
        [Validators.required, Validators.min(1)]
      ],
      destinyVehicleId: [
        transferConstructionSite.destinyVehicleId,
        [Validators.required, Validators.min(1)]
      ],
      observation: [transferConstructionSite.observation, [Validators.maxLength(250)]],
      originClientId: [transferConstructionSite?.originCostCenter?.clientId],
      originCostCenterId: [
        transferConstructionSite.originCostCenterId,
        [Validators.required, Validators.min(1)]
      ],
      originDateInvoice: [transferConstructionSite.originDateInvoice
        ? this.convertUtcToLocalDate(transferConstructionSite.originDateInvoice)
        : null, [Validators.required]],
      originSwDontChargeInvoiceDay: [transferConstructionSite.originSwDontChargeInvoiceDay],
      originTransportValue: [
        transferConstructionSite.originTransportValue,
        [Validators.required, Validators.min(0), Validators.max(99999999999.99)]
      ],
      originTransporterId: [
        transferConstructionSite.originTransporterId,
        [Validators.required, Validators.min(1)]
      ],
      originVehicleId: [
        transferConstructionSite.originVehicleId,
        [Validators.required, Validators.min(1)]
      ],
      rentalPeriodId: [transferConstructionSite.rentalPeriodId],
      transferConstructionSiteStateId: [
        transferConstructionSite.transferConstructionSiteStateId,
        [Validators.required, Validators.min(1)]
      ]
    });

    if (transferConstructionSite.transferConstructionSiteId != 0) {
      await this.getRentalPeriodByIdForRegisterInvoiceAsync();
    }

    this.updateFormState();
    this.getCostCenter(transferConstructionSite.originCostCenterId, transferConstructionSite.destinyCostCenterId);
    await Promise.all([
      this.getRemissionConsecutiveByIdAsync(transferConstructionSite.remissionId),
      this.getDevolutionConsecutiveByIdAsync(transferConstructionSite.devolutionId)
    ]);
  }

  async validateCostCenterState(costCenterId: number, side: 'origin' | 'destiny', masterList: any[]) {
    try {
      const isOrigin = side === 'origin';
      const response = await firstValueFrom(this.orderService.getCostCenterByIdForRegister(costCenterId));
      const isInactive = response.constructionSiteStateId === ConstructionSiteStateEnums.inactiva;
      if (isOrigin) {
        this.originCostCenterInvalid = isInactive;
        this.originClientInvalid = response.clientStateId === ClientStateEnums.inactivo;
      } else {
        this.destinyCostCenterInvalid = isInactive;
        this.destinyClientInvalid = response.clientStateId === ClientStateEnums.inactivo;
      }
      if (isInactive) {
        this.toastHandlerService.showToast(
          'warning',
          `El centro de costos ${isOrigin ? 'origen' : 'destino'} seleccionado se encuentra inactivo.`
        );
        if (isOrigin) {
          this.formTransferConstructionSite.patchValue({ originClientId: null, originCostCenterId: null });
          this.originCostCenters = masterList;
        } else {
          this.formTransferConstructionSite.patchValue({ destinyClientId: null, destinyCostCenterId: null });
          this.destinyCostCenters = masterList;
        }
        return;
      }
      if (isOrigin) {
        this.originCostCenters = masterList.filter(x => x.clientId === response.clientId);
        this.formTransferConstructionSite.get('originCostCenterId')?.patchValue(costCenterId);
        if (this.formTransferConstructionSite.get('originClientId')?.value !== response.clientId) {
          this.formTransferConstructionSite.get('originClientId')?.patchValue(response.clientId);
        }
      } else {
        this.destinyCostCenters = masterList.filter(x => x.clientId === response.clientId);
        this.formTransferConstructionSite.get('destinyCostCenterId')?.patchValue(costCenterId);
        if (this.formTransferConstructionSite.get('destinyClientId')?.value !== response.clientId) {
          this.formTransferConstructionSite.get('destinyClientId')?.patchValue(response.clientId);
        }
      }
    } catch (error) {
      console.error(`Error al validar el estado del centro de costos ${side}.`, error);
    }
  }

  async validateClientState(clientId: number, side: 'origin' | 'destiny') {
    try {
      const isOrigin = side === 'origin';
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      const isInactive = client.clientStateId === ClientStateEnums.inactivo;
      if (isOrigin) {
        this.originClientInvalid = isInactive;
      } else {
        this.destinyClientInvalid = isInactive;
      }

      if (isInactive) {
        this.toastHandlerService.showToast(
          'warning',
          `El cliente ${isOrigin ? 'origen' : 'destino'} seleccionado se encuentra inactivo.`
        );
      }
    } catch (error) {
      console.error('Error al validar el estado del cliente.', error);
    }
  }

  async waitForComponenteImpresionToLoad() {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<void>(async (resolve) => {
      if (this.finishLoadingPrint) {
        //Imprimimos el documento
        print();
        resolve();
      } else {
        // Si no ha terminado de cargar, espera un breve tiempo y vuelve a verificar
        setTimeout(() => this.waitForComponenteImpresionToLoad().then(resolve), 100);
      }
    });
  }
}
